<template>
  <a-select
    ref="selectEl"
    :value="value"
    :options="options"
    :open="listSelectObj.pickerOpen"
    :virtual="false"
    showSearch
    :optionFilterProp="selectFieldNames.label"
    :placeholder="placeholder"
    :fieldNames="selectFieldNames"
    :autofocus="autofocus"
    :dropdownMatchSelectWidth="dropdownMatchSelectWidth"
    :style="wrapperStyle"
    :mode="mode"
    :allowClear="allowClear"
    @dropdownVisibleChange="handleListItemVisibleChange"
    @change="handleListItemChange"
  >
    <template #option="optionItem">
      <div class="ehf-action-select-list-item flex flex-sb">
        <div class="ehf-action-select-list-item-text-block">
          <a-input
            v-if="listItemEditObj.show && listItemEditObj.form.value == optionItem[selectFieldNames.value]"
            size="small"
            :ref="(el) => listItemEditObj.form.value == optionItem[selectFieldNames.value] && (listItemEditObj.inputEl = el)"
            v-model:value="listItemEditObj.form.label"
            class="ehf-action-select-list-item-text-input"
            @pressEnter.prevent="handleEditListItem"
          ></a-input>

          <span v-else class="ehf-action-select-list-item-text">
            <!-- 支持自定义选项文案 -->
            <slot name="optionText" :optionItem="optionItem">
              {{ optionItem[selectFieldNames.label] }}
            </slot>
          </span>
        </div>
        <div class="ehf-action-select-list-item-btn-block">
          <template v-if="listItemEditObj.show && listItemEditObj.form.value == optionItem[selectFieldNames.value]">
            <!-- 编辑状态下按钮 -->
            <a-button
              class="ehf-action-select-list-item-btn btn-confirm-edit"
              title="确认编辑"
              type="text"
              size="small"
              :loading="listItemEditObj.confirmLoading"
              @click.stop="handleEditListItem"
            >
              <template #icon>
                <CheckOutlined />
              </template>
            </a-button>
            <a-button
              class="ehf-action-select-list-item-btn btn-cencel-edit"
              title="取消编辑"
              type="text"
              size="small"
              @click.stop="listItemEditObj.show = false"
            >
              <template #icon>
                <RollbackOutlined />
              </template>
            </a-button>
          </template>
          <template v-else>
            <!-- 非编辑状态下按钮 -->
            <a-button
              v-if="showEditBtn"
              class="ehf-action-select-list-item-btn btn-edit"
              title="编辑"
              type="text"
              size="small"
              @click.stop="triggerEditListItemItem(optionItem)"
            >
              <template #icon>
                <EditOutlined />
              </template>
            </a-button>
            <a-popconfirm
              v-if="typeof showDelBtnFn === 'function' && showDelBtnFn(optionItem)"
              ok-text="确定"
              cancel-text="取消"
              overlayClassName="ehf-action-select-list-item-del-popconfirm"
              :open="listSelectObj.showDelPopConfirmMap[optionItem[selectFieldNames.value]]"
              @openChange="handleListItemDelPopOpenChange(optionItem[selectFieldNames.value], $event)"
              @confirm="handleDelListItem(optionItem[selectFieldNames.value])"
              @click.stop
            >
              <template #title>
                <slot name="delOptionTipsText" :optionItem="optionItem">
                  <span>确定要删除此项？</span>
                </slot>
              </template>
              <a-button title="删除" class="ehf-action-select-list-item-btn btn-del" type="text" size="small" @click.stop>
                <template #icon>
                  <CloseOutlined />
                </template>
              </a-button>
            </a-popconfirm>
          </template>
        </div>
      </div>
    </template>
    <template #dropdownRender="{ menuNode: menu }">
      <v-nodes :vnodes="menu" />
      <a-divider style="margin: 4px 0" />
      <a-space style="padding: 4px 8px">
        <a-input v-model:value="listItemAddObj.label" @pressEnter.prevent="addListItem" placeholder="请输入名称" />
        <a-button type="text" :loading="listItemAddObj.confirmLoading" @click.stop="addListItem">
          <template #icon>
            <PlusOutlined />
          </template>
          添加
        </a-button>
      </a-space>
    </template>
  </a-select>
</template>

<script>
  export default {
    name: 'EhfActionSelect',
  }
</script>

<script setup>
  import { ref, toRefs, nextTick, defineComponent, computed, watch } from 'vue'
  import { message } from 'ant-design-vue'
  import { PlusOutlined, CloseOutlined, EditOutlined, CheckOutlined, RollbackOutlined } from '@ant-design/icons-vue'
  import { assign } from 'lodash'
  const VNodes = defineComponent({
    props: {
      vnodes: {
        type: Object,
        required: true,
      },
    },
    render() {
      return this.vnodes
    },
  })
  const props = defineProps({
    value: {
      type: [Number, String, Array],
      default: null,
    },
    options: {
      type: Array,
      default() {
        return []
      },
    },
    pickerOpen: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    fieldNames: {
      type: Object,
      default() {
        return {}
      },
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true,
    },
    wrapperStyle: {
      type: Object,
      default() {
        return {}
      },
    },
    showEditBtn: {
      type: Boolean,
      default: true,
    },
    // 自定义删除按钮的显示规则
    showDelBtnFn: {
      type: Function,
      default: null,
    },
    // 处理选项新增，需要返回promise
    handleAdd: {
      type: Function,
      default: null,
    },
    // 处理选项编辑，需要返回promise
    handleEdit: {
      type: Function,
      default: null,
    },
    // 处理选项删除，需要返回promise
    handleDel: {
      type: Function,
      default: null,
    },
    // 添加选项后自动滚动到底部
    scrollToBottomAfterAdd: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
  })
  const {
    value,
    options,
    pickerOpen,
    placeholder,
    fieldNames,
    autofocus,
    mode,
    dropdownMatchSelectWidth,
    wrapperStyle,
    handleAdd,
    handleEdit,
    handleDel,
    showEditBtn,
    scrollToBottomAfterAdd,
  } = toRefs(props)
  const selectEl = ref(null)
  const selectFieldNames = computed(() => {
    return assign({ label: 'label', value: 'value', options: 'options' }, fieldNames.value)
  })
  const emit = defineEmits(['update:value', 'change', 'dropdownVisibleChange'])
  const listSelectObj = ref({ pickerOpen: false, showDelPopConfirmMap: {} })
  // 内部pickerOpen跟随外部pickerOpen变化
  watch(
    pickerOpen,
    (newVal) => {
      if (newVal) {
        // 自动聚焦输入框
        nextTick(() => {
          selectEl.value && selectEl.value.focus()
        })
      }
      listSelectObj.value.pickerOpen = newVal
    },
    { immediate: true }
  )
  // 内部pickerOpen变化时触发外部dropdownVisibleChange
  watch(
    () => listSelectObj.value.pickerOpen,
    (newVal) => {
      emit('dropdownVisibleChange', newVal)
    }
  )
  const handleListItemDelPopOpenChange = (value, open) => {
    if (open) {
      listSelectObj.value.showDelPopConfirmMap[value] = open
    } else {
      // 为防止删除气泡关闭后使得选择下拉框也关闭，增加延迟
      setTimeout(() => {
        listSelectObj.value.showDelPopConfirmMap[value] = open
      }, 100)
    }
  }
  const listItemAddObj = ref({
    label: '',
    confirmLoading: false,
  })
  // 新增下拉选项
  const addListItem = () => {
    if (typeof handleAdd.value !== 'function') {
      return
    }
    const params = {
      label: listItemAddObj.value.label,
    }
    if (params.label.trim() === '') {
      message.warning('名称不能为空')
      return
    }
    if (isListItemNameSame(params.label)) {
      message.warning('名称不可重复')
      return
    }
    listItemAddObj.value.confirmLoading = true
    handleAdd
      .value(params)
      .then(() => {
        if (scrollToBottomAfterAdd.value && options.value.length > 0 && selectEl.value && typeof selectEl.value.scrollTo === 'function') {
          selectEl.value.scrollTo(options.value.length - 1) //滚动到最后一个选项
        }
        listItemAddObj.value.label = ''
      })
      .catch((e) => {
        message.error(e)
      })
      .finally(() => {
        listItemAddObj.value.confirmLoading = false
      })
  }
  // 检测名称是否重复
  const isListItemNameSame = (label) => {
    // 重名检测
    return options.value.some((item) => item[selectFieldNames.value.label] == label)
  }
  // 删除下拉选项
  const handleDelListItem = (value) => {
    if (typeof handleDel.value !== 'function') {
      return
    }
    listSelectObj.value.showDelPopConfirmMap[value] = false //防止出现删除后气泡闪过下一个选项对应的删除文案问题
    handleDel
      .value({ value })
      .then(() => {
        message.success('删除成功')
      })
      .catch((e) => {
        message.error(e)
      })
  }
  const getDefalutListItemEditObj = () => {
    return {
      show: false,
      confirmLoading: false,
      inputEl: null,
      form: {
        value: 0,
        label: '',
      },
    }
  }
  // 下拉选项编辑对象
  const listItemEditObj = ref(getDefalutListItemEditObj())
  // 触发下拉选项编辑
  const triggerEditListItemItem = (optionItem) => {
    if (typeof handleEdit.value !== 'function') {
      return
    }
    listItemEditObj.value = {
      show: true,
      confirmLoading: false,
      inputEl: null,
      form: {
        value: optionItem[selectFieldNames.value.value],
        label: optionItem[selectFieldNames.value.label],
      },
    }
    nextTick(() => {
      if (listItemEditObj.value.inputEl) {
        listItemEditObj.value.inputEl.focus()
      }
    })
  }
  // 下拉选项下拉框显示隐藏
  const handleListItemVisibleChange = (visible) => {
    if (visible) {
      listSelectObj.value.showDelPopConfirmMap = {}
      listSelectObj.value.pickerOpen = visible
    } else {
      // 关闭下拉框时，判断是否有删除气泡显示，如果没有，则关闭下拉框
      const hasDelPopShow = Object.values(listSelectObj.value.showDelPopConfirmMap).some((_item) => !!_item)
      if (!hasDelPopShow) {
        listSelectObj.value.pickerOpen = visible
        listItemEditObj.value = getDefalutListItemEditObj()
      }
    }
  }
  // 保存下拉选项编辑
  const handleEditListItem = () => {
    if (typeof handleEdit.value !== 'function') {
      return
    }
    const params = {
      value: listItemEditObj.value.form.value,
      label: listItemEditObj.value.form.label,
    }
    if (!params.label.trim()) {
      message.warning('名称不能为空')
      return
    }
    const oldName = (options.value.find((item) => item[selectFieldNames.value.value] === params.value) || {})[selectFieldNames.value.label]
    if (oldName && oldName == params.label) {
      // 名称相同直接取消编辑
      listItemEditObj.value.show = false
      return
    }
    if (isListItemNameSame(params.label)) {
      message.warning('名称不可重复')
      return
    }
    listItemEditObj.value.confirmLoading = true
    handleEdit
      .value(params)
      .then(() => {
        listItemEditObj.value.show = false
        message.success('保存成功')
      })
      .catch((e) => {
        message.error(e)
      })
      .finally(() => {
        listItemEditObj.value.confirmLoading = false
      })
  }
  // 下拉框值变化
  const handleListItemChange = (newValue) => {
    emit('update:value', newValue)
    emit('change', newValue)
  }
</script>

<style lang="scss" scoped>
  .ehf-action-select-list-item {
    .ehf-action-select-list-item-text {
      text-wrap: initial;
      word-break: break-all;
    }
    .ehf-action-select-list-item-btn-block {
      flex-shrink: 0;
      margin-left: 4px;
      .ehf-action-select-list-item-btn {
        color: #999;
        margin: 0 0 0 4px !important;
        &.btn-edit {
          &:hover {
            color: $ehf-color-blue-hover;
          }
        }
        &.btn-confirm-edit {
          color: #19be6b;
        }
        &.btn-del {
          &:hover {
            color: #ff7875;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .ehf-action-select-list-item-del-popconfirm {
    z-index: 9999;
  }
</style>
